import { render, staticRenderFns } from "./templatesItem.vue?vue&type=template&id=af40f4b0&lang=pug&"
import script from "./templatesItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./templatesItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./templatesItem.vue?vue&type=style&index=0&id=af40f4b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports